angular.module("adeguataVerificaClientela.components", [])
    .component("adeguataVerificaClientela", {
        templateUrl: 'ng/components/riepilogoEControllo/adeguataVerificaClientela/adeguataVerificaClientela.view.html',
        bindings: {
            model: '<',
            verifica: '=',
            readOnly: '<'
        },
        controller: AdeguataVerificaClientela,
        controllerAs: 'aDVCtrl'
    })

function AdeguataVerificaClientela(
    $configService
) {
    var self = this;

    self.$onInit = function () {
        console.log(self.model)

    }

    self.check = function (el) {
        el.selected = !el.selected;
        if (el.selected) {
            el.ndg = $configService.getUser().ndg;
            el.identifier = $configService.getUser().identifier;
            el.dataConferma = moment().format("DD/MM/YYYY");
        } else {
            el.ndg = "";
            el.identifier = "";
            el.dataConferma = "";
        }
    }
}